import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { loginAdmin } from "../lib/articlesApi";

export function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await loginAdmin(password);
      // Recarga total garante que o cookie Set-Cookie seja aplicado antes do /admin/dashboard
      const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
      window.location.assign(`${base}/admin/dashboard`);
    } catch (err) {
      setError(err.message || "Senha incorreta.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#faf9f7] flex items-center justify-center px-6 pt-28 pb-12">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#d4af37]/15 shadow-sm p-8">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#d4af37]/15 text-[#b8962e] mb-5">
          <Lock className="w-6 h-6" />
        </div>
        <h1 className="font-serif text-3xl text-[#1a1a1a] mb-2">Admin</h1>
        <p className="text-slate-600 mb-6">Informe a senha para acessar o painel.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">Senha</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" className="w-full bg-[#d4af37] hover:bg-[#b8962e] text-[#1a1a1a]" disabled={loading}>
            {loading ? "Validando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </main>
  );
}
